import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { RecalculateSummarySalesPage } from './recalculate-summary-sales.page';

const routes: Routes = [
  {
    path: '',
    component: RecalculateSummarySalesPage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class RecalculateSummarySalesPageRoutingModule {}
